import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);


export default function HorizontalBarChart({ data, title, horizontal, left }) {
    const options = {
        indexAxis: horizontal ?? 'x',                // Rende le barre orizzontali
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
                position: 'top'
            },
            title: {
                display: true,
                text: title,
                font: {
                    size: 20,
                },
                color: '#fff'
            }, datalabels: { display: false }
        },
        scales: {
            x: {
                beginAtZero: true, ticks: {
                    font: {
                        size: 16,
                    },
                    color: '#fff'
                },
                stacked: true,
            },
            y: {

                ticks: {

                    color: '#fff'
                },
                stacked: true,
            }
        }
    };
    // assicurati che ogni dataset abbia un label (sarà mostrato in legenda)
    const chartData = data && data.datasets ? {
        ...data,
        datasets: data.datasets.map(ds => ({
            label: ds.label ?? 'valore',
            backgroundColor: ds.backgroundColor ?? ds.borderColor ?? 'rgba(75,192,192,0.6)',
            ...ds
        }))
    } : data;

    return (
        <div className='graph' style={left ? { marginRight: 'auto', marginLeft: '5%' } : {}} >
            <Bar data={chartData} options={options} />
        </div>
    );

}
